import { MediaImage } from "@/components/admin/MediaAsset";
import { MessageCircle } from "lucide-react";

export default function WidgetPreview({ name, brandColor, logoUrl, greeting, quickReplies = [], position = "bottom-right" }) {
  const brand = brandColor || "#2563EB";
  const left = position === "bottom-left";
  return (
    <div className="space-y-3" data-testid="widget-live-preview">
      {/* Position simulation: mini screen with floating icon at chosen corner */}
      <div className="relative w-full h-24 rounded-xl border border-[#E2E8F0] bg-[#F8FAFC] overflow-hidden" data-testid="position-preview">
        <div className="absolute top-2 left-2 right-2 h-3 rounded bg-[#F1F5F9]" />
        <div className="absolute top-7 left-2 w-1/2 h-2 rounded bg-[#F1F5F9]" />
        <div className="absolute top-11 left-2 w-2/3 h-2 rounded bg-[#F1F5F9]" />
        <div
          className={`absolute bottom-2 ${left ? "left-2" : "right-2"} w-9 h-9 rounded-full flex items-center justify-center text-white shadow-lg`}
          style={{ backgroundColor: brand }}
          data-testid={`position-icon-${left ? "left" : "right"}`}
        >
          <MessageCircle size={16} />
        </div>
        <span className={`absolute bottom-3 ${left ? "left-14" : "right-14"} text-[10px] text-slate-500`}>
          {left ? "Kiri bawah" : "Kanan bawah"}
        </span>
      </div>

      <div className="w-full max-w-[330px] rounded-2xl overflow-hidden border border-[#E2E8F0] shadow-2xl bg-[#FFFFFF]">
        <div className="px-4 py-3 flex items-center gap-2.5 text-white" style={{ backgroundColor: brand }}>
          {logoUrl ? (
            <MediaImage src={logoUrl} alt="logo" className="w-9 h-9 rounded-full object-cover border-2 border-white/40 shrink-0" onError={(e) => { e.target.style.display = "none"; }} />
          ) : (
            <div className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center shrink-0"><MessageCircle size={18} /></div>
          )}
          <div className="min-w-0">
            <p className="font-heading font-bold text-sm leading-tight truncate">{name || "Nama Bisnis"}</p>
            <p className="text-[11px] opacity-80 leading-tight">Biasanya membalas instan</p>
          </div>
        </div>
        <div className="p-3 space-y-3 bg-[#F8FAFC] min-h-[160px]">
          <div className="flex justify-start">
            <div className="max-w-[80%] px-3 py-2 rounded-2xl rounded-bl-sm text-sm bg-[#F1F5F9] text-slate-900">
              {greeting || "Halo! Ada yang bisa kami bantu?"}
            </div>
          </div>
          {quickReplies.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {quickReplies.map((q, i) => (
                <span key={i} className="text-xs bg-[#F1F5F9] border border-[#E2E8F0] rounded-full px-3 py-1.5 text-slate-800">{q}</span>
              ))}
            </div>
          )}
        </div>
        <div className="p-2 border-t border-[#E2E8F0] bg-[#FFFFFF] flex items-center gap-2">
          <div className="flex-1 bg-[#F1F5F9] border border-[#E2E8F0] rounded-full px-4 py-2 text-xs text-slate-500">Tulis pesan...</div>
          <div className="w-9 h-9 rounded-full flex items-center justify-center text-white shrink-0" style={{ backgroundColor: brand }}>
            <MessageCircle size={15} />
          </div>
        </div>
      </div>
    </div>
  );
}
